export function getUpperLeftCorner(target: (createjs.Container | createjs.DisplayObject)): {x: number, y: number} {
    const bounds = target.getBounds();

    if (!bounds) {
        throw new Error(`Could not calculate bounds for target objects ${target}`);
    }

    const pos = target.localToGlobal(bounds.x, bounds.y);

    let scaleX = 1;
    let scaleY = 1;
    let el = target;
    while (el.parent) {
        // TODO: should be while `el`?
        scaleX = scaleX * (el.scaleX || 1);
        scaleY = scaleY * (el.scaleY || 1);

        el = el.parent;
    }

    let x;
    if (scaleX === -1) {
        x = pos.x - bounds.width;
    } else {
        x = pos.x;
    }

    let y;
    if (scaleY === -1) {
        y = pos.y - bounds.height;
    } else {
        y = pos.y;
    }

    return {x, y};
}
